var baseUrl = ""
var weChatCallBackUrl = ""

//测试环境
// baseUrl = "https://pre.weiyoubot.cn";
//线上环境
baseUrl = "https://api-xcx.qunsou.co";


var checkin = {
	upload: '/xcx/checkin_web/v1/upload', //新增的上传文件，感觉用不上了
	uploadPic: '/xcx/file/v1/upload', //小程序的上传图片
	uploadAudio: '/xcx/audio/upload',//小程序的上传语音
	uploadVideo: '/xcx/checkin/v1/upload/video',//小程序的上传视频
	getCheckinDetail: '/xcx/checkin/v5/detail', //获取签到详情
  joinCheckin: '/xcx/checkin/v5/join', //加入签到
	getQr: '/xcx/checkin/v3/qrcode',
  submit: '/xcx/checkin/v3/doit', //发布签到
}

export default {
	baseUrl,
	checkin,
}



// WEBPACK FOOTER //
// ./src/utils/api.js